import { SVGProps } from 'react';

const HalfFieldIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        width="100%"
        height="100%"
        viewBox="0 0 450 450"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlSpace="preserve"
        style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: 1.5,
        }}
        {...props}
    >
        <g id="Half_Field">
            <path d="M421.794,14.902l2.52,1.284l2,2l1.284,2.52l0.442,2.794l0,374.25l-0.442,2.794l-1.284,2.52l-2,2l-2.52,1.284l-2.794,0.442l-384,0l-2.794,-0.442l-2.52,-1.284l-2,-2l-1.284,-2.52l-0.442,-2.794l0,-374.25l0.442,-2.794l1.284,-2.52l2,-2l2.52,-1.284l2.794,-0.442l384,0l2.794,0.442Zm-386.794,8.598l0,374.25l384,0l0,-374.25l-384,0Z" />
            <path d="M35,167l384,0" style={{ fill: 'none', strokeWidth: 8.5 }} />
            <path d="M113,167l0,230.75" style={{ fill: 'none', strokeWidth: 8.5 }} />
            <path d="M341,167l0,230.75" style={{ fill: 'none', strokeWidth: 8.5 }} />
            <path d="M341,23.5l0,47.75" style={{ fill: 'none', strokeWidth: 8.5 }} />
        </g>
    </svg>
);

export default HalfFieldIcon;
